<template>
  <div id="partner">
    <div class="toolbar">
      <div style="min-width: 1200px;">
        <div class="form-group">
          <label>기간</label>
          <date-range-picker ref="picker"
                             :class="['vue-daterange-picker-md', {'active': isActivePicker}]"
                             :auto-apply="dateRangeOptions.openApply"
                             :showDropdowns="dateRangeOptions.showDropdowns"
                             :opens="dateRangeOptions.opens"
                             :locale-data="dateRangeOptions.locale"
                             :ranges="dateRangeOptions.ranges"
                             :min-date="dateRangeOptions.minDate"
                             :max-date="dateRangeOptions.maxDate"
                             @toggle="bool => isActivePicker = bool"
                             @update="convertDate"
                             v-model="dateRange"
          >
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>원클릭 검토수</label>
          <div>
            <input type="number"
                   class="hz-input-default hz-input-md"
                   min="0"
                   max="999"
                   @keyup.enter="search"
                   v-model.number="filterObj.oneclick_search"
            >
            <span>이상</span>
          </div>
        </div>
        <div class="form-group">
          <label>원클릭 저장수</label>
          <div>
            <input type="number"
                   class="hz-input-default hz-input-md"
                   min="0"
                   max="999"
                   @keyup.enter="search"
                   v-model.number="filterObj.oneclick_save"
            >
            <span>이상</span>
          </div>
        </div>
        <div class="form-group">
          <label>프리미엄 저장수</label>
          <div>
            <input type="number"
                   class="hz-input-default hz-input-md"
                   min="0"
                   max="999"
                   @keyup.enter="search"
                   v-model.number="filterObj.premium_save"
                   required
            >
            <span>이상</span>
          </div>
        </div>
        <div class="form-group">
          <label>제품구매 신청수</label>
          <div>
            <input type="number"
                   class="hz-input-default hz-input-md"
                   min="0"
                   max="999"
                   @keyup.enter="search"
                   v-model.number="filterObj.shop_application"
            >
            <span>이상</span>
          </div>
        </div>
        <div class="form-group">
          <label>잔여기간(일)</label>
          <div>
            <input type="number"
                   class="hz-input-default hz-input-md"
                   min="0"
                   max="999"
                   @keyup.enter="search"
                   v-model.number="filterObj.rest_days"
            >
            <span>이하</span>
          </div>
        </div>
        <button type="button" class="hz-btn-default hz-btn-md disabled" @click="search">검색</button>
        <button class="hz-btn-default hz-btn-md" style="width: 40px;" title="필터 초기화" @click="initFilter">
          <i class="glyphicon glyphicon-repeat" style="top: 2px; font-size: 14px;"></i>
        </button>
      </div>
    </div>
    <div class="grid">
      <kendo-grid ref="grid"
                  :auth="true"
                  :columns="tableFields"
                  :dataUrl="tableUrl"
                  :options="tableOptions"
                  :size="'none'"
                  :message="'회원사 목록이 없습니다.'">
      </kendo-grid>
      <fab :linkList="fabLinkList"
           @showCouponModal="$refs.couponModal.show()"
           @download="$refs.grid.download()"
      >
      </fab>
    </div>
    <modal :id="'couponModal'" ref="couponModal" class="hz-modal-default">
      <div class="modal-header">
        <h4 class="modal-title" id="couponModalLabel">쿠폰발급</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-4">종류</label>
          <div class="col-md-8">
            <drop-down-list
              :fields="{'text': 'name', 'value': 'id'}"
              :options="couponTypes"
              :label="''"
              @input="clearError"
              v-model="couponData.type"
            >
            </drop-down-list>
          </div>
        </div>
        <div class="form-group" v-show="couponData.type !== 'discount'">
          <label class="col-md-4">이용기간(일)</label>
          <div class="col-md-8">
            <input-count :max="365"
                         @update="(num) => couponData.period = num"
                         v-model.number="couponData.period"
            >
            </input-count>
          </div>
        </div>
        <div class="form-group" v-show="couponData.type !== 'discount'">
          <label class="col-md-4">출력가능횟수</label>
          <div class="col-md-8">
            <input-count :readonly="true"
                         :max="1000"
                         @update="(num) => couponData.point = num"
                         v-model.number="couponData.point"
            >
            </input-count>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-4">쿠폰이름</label>
          <div class="col-md-8">
            <input type="text"
                   class="hz-input-default hz-input-lg"
                   autocomplete="off"
                   minlength="1"
                   maxlength="10"
                   data-vv-name="coupon_name"
                   v-validate="{required: true}"
                   v-model="couponData.name"
                   placeholder="예) 1월 프로모션 쿠폰"
            >
            <p class="is-invalid-text">{{ errors.first('coupon_name') }}</p>
          </div>
        </div>
        <div class="form-group" v-show="couponData.type === 'event'">
          <label class="col-md-4">쿠폰코드</label>
          <div class="col-md-8">
            <input type="text"
                   class="hz-input-default hz-input-lg"
                   data-vv-name="promotion_code"
                   v-validate="{required: true}"
                   minlength="1"
                   maxlength="50"
                   placeholder="예) welcome-biz"
                   v-model="couponData.promotion_code"
            >
            <p class="is-invalid-text">{{ errors.first('promotion_code') }}</p>
          </div>
        </div>
        <div class="form-group" v-show="couponData.type === 'discount'">
          <label class="col-md-4">할인내용</label>
          <div class="col-md-8">
            <input type="text"
                   class="hz-input-default hz-input-lg"
                   data-vv-name="discount_desc"
                   v-validate="{required: true}"
                   minlength="1"
                   maxlength="50"
                   placeholder="예) 30만원 할인, 10% 할인"
                   v-model="couponData.discount"
            >
            <p class="is-invalid-text">{{ errors.first('discount_desc') }}</p>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-4">쿠폰등록 만료일</label>
          <div class="col-md-8">
            <date-picker :size="'hz-picker-lg'"
                         :placeholder="'쿠폰등록 만료일을 입력해주세요.'"
                         :options="{min: new Date()}"
                         v-model="couponData.event_expiration_date"
            >
            </date-picker>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-4">쿠폰발송</label>
          <div class="col-md-8">
            <div class="checkbox">
              <label>
                <input type="checkbox" value="kakao" v-model="couponData.send_coupon_way">
                <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                카카오(문자)
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input type="checkbox" value="email" v-model="couponData.send_coupon_way">
                <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                이메일
              </label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-4">관리자메모</label>
          <div class="col-md-8">
            <textarea class="hz-input-default" placeholder="예) 안혜진님 요청 - 대여사업 협력사 대상 발급" v-model="couponData.memo"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <p class="explain-text" v-if="invalidCreateCoupon">선택된 회원사가 있을 경우 이벤트 쿠폰 발급은 불가합니다.</p>
        <p class="explain-text" v-else>{{ checkedPartnerCountText }}</p>
        <button type="button" class="hz-btn-primary hz-btn-lg" style="width: 183px" :disabled="invalidCreateCoupon" @click="validate">발급하기</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import DropDownList from 'common/components/DropDownList'
  import DatePicker from 'common/components/DatePicker'
  import DateRangePicker from 'vue2-daterange-picker'
  import InputCount from '@/components/InputCount'
  import Fab from '@/components/admin/Fab'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from '@/components/Modal'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import { mapActions } from 'vuex'

  export default {
    name: 'partner',
    components: {
      DropDownList,
      DatePicker,
      DateRangePicker,
      Fab,
      InputCount,
      KendoGrid,
      Modal
    },
    data () {
      return {
        isActivePicker: false,
        tableUrl: '',
        dateRange: {
          startDate: null,
          endDate: null
        },
        dateRangeOptions: {
          minDate: null,
          maxDate: null,
          openApply: true,
          showDropdowns: true,
          opens: 'right',
          locale: {
            direction: 'ltr',
            format: 'yyyy.mm.dd',
            separator: ' ~ ',
            applyLabel: '적용',
            cancelLabel: '취소',
            weekLabel: 'W',
            daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
            monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            firstDay: 0
          },
          ranges: false
        },
        filterObj: {
          oneclick_search: 0,
          oneclick_save: 0,
          premium_save: 0,
          shop_application: 0,
          rest_days: 0
        },
        couponData: {
          type: 'coupon',
          name: '',
          promotion_code: '',
          discount: '',
          memo: '',
          period: 30,
          point: 1000,
          event_expiration_date: '',
          send_coupon_way: ['kakao', 'email'],
          target_user_id_list: []
        },
        couponTypes: [
          { id: 'coupon', name: '일반쿠폰' },
          { id: 'event', name: '이벤트쿠폰' },
          { id: 'discount', name: '할인쿠폰' }
        ],
        fabLinkList: [
          {
            id: 'download',
            tooltip: '다운로드',
            callback: 'download',
            src: require('../../assets/svg/ic-download.svg')
          },
          {
            id: 'coupon',
            tooltip: '쿠폰발급',
            callback: 'showCouponModal',
            src: require('../../assets/svg/ic-coupon.svg')
          }
        ],
        tableFields: [
          {
            title: 'Select All',
            locked: true,
            lockable: false,
            headerTemplate: `<input type='checkbox' id='header-chb' class='k-checkbox header-checkbox'><label class='k-checkbox-label' for='header-chb'></label>`,
            template: (item) => {
              return `<input type='checkbox' id='${item.user_id}' class='k-checkbox row-checkbox'><label class='k-checkbox-label' for='${item.user_id}'></label>`
            },
            width: 45
          },
          {
            field: 'name',
            title: '회원사명',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            // filterable: { multi: true, search: true },
            filterable: false,
            locked: true,
            lockable: false,
            width: '200px',
            template (item) {
              return item.name === '' ? '-' : item.name
            }
          },
          {
            field: 'pic_name',
            title: '담당자',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            // filterable: { multi: true, search: true },
            filterable: false,
            width: '120px',
            template (item) {
              return item.pic_name === '' ? '-' : item.pic_name
            }
          },
          {
            field: 'pic_contact',
            title: '담당자 연락처',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            // filterable: { multi: true, search: true },
            filterable: false,
            width: '150px',
            template (item) {
              return item.pic_contact === '' ? '-' : item.pic_contact
            }
          },
          {
            field: 'pic_email',
            title: '담당자 이메일',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            // filterable: { multi: true, search: true },
            filterable: false,
            width: '200px',
            template (item) {
              return item.pic_email === '' ? '-' : item.pic_email
            }
          },
          {
            field: 'address',
            title: '주소',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            // filterable: { extra: false },
            filterable: false,
            width: '300px',
            template (item) {
              return item.address === '' ? '-' : `${item.address} ${item.rest_address}`
            }
          },
          {
            field: 'region',
            title: '지역',
            type: 'string',
            // filterable: { multi: true, search: true },
            filterable: false,
            sortable: true,
            width: '120px',
            template (item) {
              return item.region === '' ? '-' : `${item.region}`
            }
          },
          {
            field: 'agree_promotion',
            title: '마케팅동의',
            type: 'boolean',
            // filterable: { multi: true, search: true },
            filterable: false,
            width: '100px',
            template (item) {
              return item.agree_promotion ? 'O' : 'X'
            }
          },
          {
            field: 'oneclick_search',
            title: '원클릭 검토수',
            type: 'string',
            filterable: false,
            sortable: {
              initialDirection: 'desc'
            },
            width: '120px'
          },
          {
            field: 'oneclick_save',
            title: '원클릭 저장수',
            type: 'string',
            filterable: false,
            sortable: {
              initialDirection: 'desc'
            },
            width: '120px'
          },
          {
            field: 'premium_save',
            title: '프리미엄 저장수',
            type: 'string',
            filterable: false,
            sortable: {
              initialDirection: 'desc'
            },
            width: '120px'
          },
          {
            field: 'shop_application',
            title: '제품구매 신청수',
            type: 'string',
            filterable: false,
            sortable: {
              initialDirection: 'desc'
            },
            width: '120px'
          },
          {
            field: 'last_login_datetime',
            title: '최근접속일',
            type: 'date',
            // filterable: {
            //   operators: {
            //     date: {
            //       eq: '같음',
            //       gte: '이후',
            //       lte: '이전'
            //     }
            //   }
            // },
            filterable: false,
            sortable: true,
            width: '120px',
            template (item) {
              return item.last_login_datetime === null ? '-' : kendo.toString(kendo.parseDate(item.last_login_datetime), 'yyyy.MM.dd')
            }
          },
          {
            field: 'expiration_date',
            title: '이용종료일',
            type: 'date',
            filterable: false,
            sortable: false,
            width: '120px',
            template (item) {
              return item.expiration_date === null ? '-' : kendo.toString(kendo.parseDate(item.expiration_date), 'yyyy.MM.dd')
            }
          },
          {
            field: 'rest_days',
            title: '잔여기간',
            type: 'string',
            width: '150px',
            filterable: false,
            sortable: true,
            template (item) {
              return item.rest_days === '' ? '-' : `${item.rest_days}일`
            }
          },
          {
            field: 'auth_level',
            title: '회원등급',
            type: 'string',
            // filterable: { multi: true, search: true },
            filterable: false,
            width: '120px'
          },
          {
            field: 'recent_issue',
            title: '최근상담이력',
            type: 'string',
            width: '200px',
            attributes: { class: 'show-tooltip' },
            filterable: false,
            sortable: false,
            template (item) {
              return item.recent_issue === '' ? '-' : item.recent_issue
            }
          }
        ],
        tableOptions: {
          selectable: false,
          excel: {
            fileName: `${moment().format('YYMMDD')}_partner_list.xlsx`
          },
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            refresh: true,
            buttonCount: 5,
            pageSize: 100,
            pageSizes: [100, 500, 1000, 'all'],
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          },
          filterMenuInit: function (e) {
            // 기간검색 필터 일 경우
            if (['reg_date', 'coupon__reg_date', 'expiration_date'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('gte')
              firstValueDropDown.trigger('change')

              const secondValueDropDown = e.container.find('select:eq(2)').data('kendoDropDownList')
              secondValueDropDown.value('lte')
              secondValueDropDown.trigger('change')
            }
            // 단일검색 필터 일 경우
            if (['coupon__promotion_code', 'coupon__memo'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('contains')
              firstValueDropDown.trigger('change')
            }
          }
        }
      }
    },
    watch: {
      'filterObj.oneclick_search': {
        handler (val) {
          const parseValue = val === '' ? 0 : parseInt(val)
          this.filterObj.oneclick_search = parseValue
        }
      },
      'filterObj.oneclick_save': {
        handler (val) {
          const parseValue = val === '' ? 0 : parseInt(val)
          this.filterObj.oneclick_save = parseValue
        }
      },
      'filterObj.premium_save': {
        handler (val) {
          const parseValue = val === '' ? 0 : parseInt(val)
          this.filterObj.premium_save = parseValue
        }
      },
      'filterObj.shop_application': {
        handler (val) {
          const parseValue = val === '' ? 0 : parseInt(val)
          this.filterObj.shop_application = parseValue
        }
      },
      'filterObj.rest_days': {
        handler (val) {
          const parseValue = val === '' ? 0 : parseInt(val)
          this.filterObj.rest_days = parseValue
        }
      }
    },
    computed: {
      checkedPartnerCountText () {
        return `${this.couponData.target_user_id_list.length}개 회원사가 선택되었습니다.`
      },
      invalidCreateCoupon () {
        // 선택된 회원사가 있을 경우 이벤트 쿠폰 발급 불가
        const couponData = this.couponData
        return couponData.type === 'event' && couponData.target_user_id_list.length > 0
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      clearError () {
        this.errors.clear()
        $('#couponModal').find('.is-invalid').removeClass('is-invalid')
      },
      convertDate () {
        this.dateRange = {
          startDate: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.dateRange.endDate).format('YYYY-MM-DD')
        }
      },
      createCoupon () {
        let copyCouponData = _.cloneDeep(this.couponData)

        // 할인쿠폰 일 경우 기간을 0으로 설정한다.
        if (copyCouponData.type === 'discount') {
          copyCouponData.period = 0
        }
        copyCouponData.send_coupon_way = copyCouponData.send_coupon_way.toString()
        copyCouponData.target_user_id_list = copyCouponData.target_user_id_list.toString()

        axios.post('/biz/pricing/coupon/', copyCouponData)
          .then(response => {
            this.$refs.couponModal.hide()
            this.showToastMessage('쿠폰발급 완료')
          })
          .catch(error => {
            this.$refs.couponModal.hide()
            this.showToastMessage(`쿠폰발급 실패 (${error.response.data.message})`)
          })
      },
      getCheckedIds () {
        let list = []
        const checkedNodeList = this.$refs.grid.$el.querySelectorAll('tbody td .k-checkbox:checked')

        for (let i = 0; i < checkedNodeList.length; i++) {
          list.push(checkedNodeList[i].id)
        }

        return list
      },
      initFilter () {
        this.filterObj = {
          oneclick_search: 0,
          oneclick_save: 0,
          premium_save: 0,
          shop_application: 0,
          rest_days: 0
        }

        this.$nextTick(() => {
          this.search()
        })
      },
      search () {
        const queryObj = Object.assign({
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate
        }, this.filterObj)

        const url = `${location.protocol}//${location.hostname.replace('biz', 'api')}/biz/partner/`
        const query = new URLSearchParams(queryObj).toString()

        // 회원사 목록 URL 초기화
        this.tableUrl = `${url}?${query}`
      },
      validate () {
        // 선택된 쿠폰 타입에 따라 validation 처리
        const validateTargets = {
          coupon: ['coupon_name'],
          event: ['coupon_name', 'promotion_code'],
          discount: ['coupon_name', 'discount_desc']
        }

        for (let target of validateTargets[this.couponData.type]) {
          this.$validator.validate(target)
        }

        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.createCoupon()
          }
        })
      }
    },
    created () {
      const today = moment().format('YYYY-MM-DD')

      // 현재 달의 1일과 현재 날짜로 초기화
      this.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.dateRange.endDate = today

      // 캘린더 선택가능 범위 설정
      this.dateRangeOptions.minDate = moment('2018-12-31').format('YYYY-MM-DD')
      this.dateRangeOptions.maxDate = today

      // 쿠폰등록 만료일 초기값 설정
      this.couponData.event_expiration_date = moment().add(30, 'd').format('YYYY-MM-DD')

      this.search()
    },
    mounted () {
      // 회원사 전체 선택,해제 이벤트 등록
      const grid = this.$refs.grid.$el
      const headerCheckcbox = grid.querySelector('#header-chb')

      headerCheckcbox.addEventListener('click', function (e) {
        const childCheckBoxList = grid.querySelectorAll('tbody td .k-checkbox')

        if (childCheckBoxList.length > 0) {
          for (let checkbox of childCheckBoxList) {
            checkbox.checked = e.target.checked
          }
        }
      })

      // 쿠폰등록 모달 이벤트 리스너 등록
      const couponModal = $('#couponModal')

      couponModal.on('show.bs.modal', () => {
        this.couponData.target_user_id_list = this.getCheckedIds()
        this.clearError()
      })

      couponModal.on('hidden.bs.modal', () => {
        this.couponData = {
          type: 'coupon',
          name: '',
          promotion_code: '',
          discount: '',
          memo: '',
          period: 30,
          point: 1000,
          event_expiration_date: moment().add(30, 'd').format('YYYY-MM-DD'),
          send_coupon_way: ['kakao', 'email'],
          target_user_id_list: []
        }
      })
    },
    beforeDestroy () {
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/css/components/daterange_picker';
  @import '~@/assets/css/components/grid';
</style>


<style lang="scss" scoped>
  .toolbar {
    height: 72px;
    width: 100%;
    padding: 8px 16px;

    .form-group {
      display: inline-block;
      width: 120px;
      margin: 0 8px;

      &:first-child {
        width: 240px;
        margin: 0 8px 0 0;
      }

      div {
        position: relative;
      }

      label {
        display: block;
        margin: 0 0 4px;
        color: $font-color;
      }

      input {
        width: 100%;
      }

      span {
        position: absolute;
        top: 8px;
        right: 8px;
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
        color: $hzc-gray-05;
      }
    }

    button {
      display: inline-block;
      width: 124px;
    }
  }

  .grid {
    height: calc(100% - 72px);
  }

  .hz-modal-default {
    .modal-title {
      display: inline-block;
      font-size: 26px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: -1px;
      color: $header-color;
    }

    .modal-footer {
      text-align: center;
    }

    .close  {
      margin: 6px 0 0;

      span {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        color: $hzc-gray-05;
      }
    }

    .form-group {
      line-height: 48px;
    }

    .hz-input-default {
      width: 100%;
    }

    .checkbox {
      margin: 0;
      display: inline-block;

      &:first-child {
        margin: 0 32px 0 0;
      }
    }

    .explain-text {
      margin: 0 0 16px;
      font-size: 16px;
    }

    textarea {
      padding: 0 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/Partner.vue